import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import ContentWithTooltip from './ContentWithTooltip';
import styles from './PaymentMethods.css';


function PaymentMethod(props) {
  const {
    handleSelection,
    isSelected,
    method,
    mobileView,
  } = props;

  const [toolTipVisible, setToolTipVisible] = useState(false);

  const handleTooltipClose = useCallback(() => {
    setToolTipVisible(false);
  }, []);

  const handleTooltipOpen = useCallback(() => {
    setToolTipVisible(true);
  }, []);

  if (mobileView) {
    return (
      <ClickAwayListener
        mouseEvent="onMouseDown"
        onClickAway={handleTooltipClose}
      >
        <div
          className={styles.methodWrapper}
          onClick={handleTooltipOpen}
        >
          <ContentWithTooltip
            handleSelection={handleSelection}
            isSelected={isSelected}
            method={method}
            toolTipVisible={toolTipVisible}
          />
        </div>
      </ClickAwayListener>
    );
  }

  return (
    <div
      className={styles.methodWrapper}
      onMouseEnter={handleTooltipOpen}
      onMouseLeave={handleTooltipClose}
    >
      <ContentWithTooltip
        handleSelection={handleSelection}
        isSelected={isSelected}
        method={method}
        toolTipVisible={toolTipVisible}
      />
    </div>
  );
}

PaymentMethod.propTypes = {
  handleSelection: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  method: PropTypes.object.isRequired,
  mobileView: PropTypes.bool.isRequired,
};

export default PaymentMethod;
